import { objectSpread2 as _objectSpread2 } from '../_virtual/_rollupPluginBabelHelpers.js';
import VueCompositionAPI, { reactive } from '@vue/composition-api';
import Vue from 'vue';
import localeValues from '../locale/lang/zh-CN.js';

var isCompositionInstall = Object.hasOwnProperty.call(Vue, '__composition_api_installed__');

if (!isCompositionInstall) {
  Vue.use(VueCompositionAPI);
}
/**
 * 全局的配置文件
 */


var globalConfigs = reactive({
  locale: localeValues,
  direction: 'ltr'
});
var Config = {
  // 获取多语言配置
  getLocale: function getLocale() {
    return globalConfigs.locale;
  },
  // 切换多语言配置
  useLocale: function useLocale(locales) {
    globalConfigs.locale = locales;
  },
  // 修改多语言的指定key
  changeLocale: function changeLocale(locales) {
    globalConfigs.locale = _objectSpread2(_objectSpread2({}, globalConfigs.locale), locales);
  },
  getDirection: function getDirection() {
    return globalConfigs.direction;
  },
  setDirection: function setDirection(direction) {
    globalConfigs.direction = direction;
  }
};

export { Config, Config as default, isCompositionInstall };
//# sourceMappingURL=index.js.map
